
import React from "react"


import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { toast } from "sonner"
import { useAuth } from "./useAuth"

type CommonArea = {
  id: string
  name: string
  description: string
  operating_hours: string
  max_capacity: number
  status: 'available' | 'occupied' | 'maintenance'
  image_emoji: string
  condominium_id: string
  created_at: string
  updated_at: string
  is_active: boolean
}

export const useCommonAreas = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["common-areas", profile?.condominium_id],
    queryFn: async () => {
      if (!profile?.condominium_id) return []

      const { data, error } = await supabase
        .from("common_areas")
        .select("*")
        .eq("condominium_id", profile.condominium_id)
        .eq("is_active", true)
        .order("name")

      if (error) throw error
      return data as CommonArea[]
    },
    enabled: !!profile?.condominium_id
  })
}

export const useCreateCommonArea = () => {
  const queryClient = useQueryClient()
  const { profile } = useAuth()

  return useMutation({
    mutationFn: async (data: Omit<CommonArea, 'id' | 'created_at' | 'updated_at' | 'condominium_id'>) => {
      if (!profile?.condominium_id) throw new Error("Condomínio não encontrado")

      const { data: area, error } = await supabase
        .from("common_areas")
        .insert({
          ...data,
          condominium_id: profile.condominium_id
        })
        .select()
        .single()

      if (error) throw error
      return area
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["common-areas"] })
      toast.success("Área comum criada com sucesso!")
    },
    onError: (error) => {
      console.error("Erro ao criar área comum:", error)
      toast.error("Erro ao criar área comum")
    }
  })
}
